import { addBaseUrl } from "~/modules/app/seo/addBaseUrl";
import { Routes } from "~/routes";
import { MediaCitation } from "../types";
import { getMediaCitationsJsonLd } from "./getMediaCitationsJsonLd";

// // // //

/**
 * Citation titles + publisher names are authored outside this codebase, so a
 * literal `</script>` in one of them would close the tag early. Escaping `<`
 * keeps the payload valid JSON while making that impossible.
 */
function serializeJsonLd(jsonLd: Record<string, unknown>): string {
    return JSON.stringify(jsonLd).replace(/</g, "\\u003c");
}

// // // //

/**
 * MediaCitationsSEO
 * Renders CollectionPage JSON-LD for the /citations page so search engines and
 * language models can read the citation list as machine-readable evidence that
 * these publishers reference RWA.xyz.
 *
 * NOTE: we build the JSON-LD by hand because next-seo has no CollectionPage
 * primitive - same approach as WebsiteJsonLd + ManagerIndividualSEO.
 *
 * @see https://schema.org/CollectionPage
 * @see https://schema.org/citation
 */
export function MediaCitationsSEO(props: {
    citations: MediaCitation[];
    name: string;
    description: string;
}) {
    const { citations, name, description } = props;

    const jsonLd = getMediaCitationsJsonLd({
        citations,
        pageUrl: addBaseUrl(Routes.citations),
        productUrl: addBaseUrl(Routes.home),
        name,
        description,
    });

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: serializeJsonLd(jsonLd) }}
        />
    );
}
